import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {ErrorsObject} from '../../../shared/utilities/error-utility.utility';
import * as fromModuleModels from '../../models';
import {FormsService} from '../../../shared/services';

@Component({
  selector: 'special-agreement-form',
  styleUrls: ['special-agreement-form.component.scss'],
  template: `

    <div class="card mat-elevation-z1">

      <div class="card__heading">
        <span>{{ presets$.getValue() ? 'Sondervereinbarung bearbeiten' : 'Neue Sondervereinbarung anlegen' }}</span>
      </div>

      <div class="card__content p-a--24" [formGroup]="saf">

        <div class="grid">

          <mat-form-field class="column-14">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name" required>
            <mat-hint align="start" *ngIf="errors?.name">{{ errors.name.message }}</mat-hint>
          </mat-form-field>

          <div class="column-14 m-b--32 mat-form-field">
            <app-text-editor formControlName="content" placeholder="Inhalt eingeben"></app-text-editor>
            <mat-hint align="start" *ngIf="errors?.content">{{ errors.content.message }}</mat-hint>
          </div>

          <div class="m-ta--2 column-14">

            <button *ngIf="presets$.getValue() || saf.dirty" class="m-r--16" (click)="cancelEdit()" type="button"
                    color="outline" mat-flat-button>
              <mat-icon class="m-r--8">cancel</mat-icon>
              <span>Abbrechen</span>
            </button>

            <button [disabled]="saf.invalid || saf.untouched" (click)="handleSubmit()" mat-flat-button color="green">
              <mat-icon class="m-r--8">save</mat-icon>
              <span>{{ presets$.getValue() ? 'Aktualisieren' : 'Anlegen' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SpecialAgreementFormComponent implements OnInit {

  @Input() errors: ErrorsObject;
  @Input() presets$: BehaviorSubject<any>;

  @Output() requestCreateItem: EventEmitter<{
    payload: fromModuleModels.SpecialAgreement,
    entity: string
  }> = new EventEmitter();
  @Output() requestUpdateItem: EventEmitter<{
    iri: string,
    payload: fromModuleModels.SpecialAgreement,
    entity: string
  }> = new EventEmitter();

  saf: FormGroup;

  onDestroy$: Subject<any> = new Subject<any>();

  constructor(private fb: FormBuilder, private fs: FormsService) {
  }

  ngOnInit(): void {
    this.presets$.pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(preset => {
      this.initForm();
      this.fs.patchForm(this.saf, preset);
      this.saf.markAsUntouched();
    });
  }

  initForm() {
    this.saf = this.fb.group({
      name: this.fb.control(null, [Validators.required, Validators.minLength(2), Validators.maxLength(35)]),
      content: this.fb.control(null, [Validators.required])
    });
  }

  cancelEdit() {
    this.initForm();
    this.presets$.next(null);
  }

  handleSubmit(): void {

    const payload: fromModuleModels.SpecialAgreement = this.saf.value;

    !this.presets$.getValue()
      ? this.requestCreateItem.emit({payload, entity: 'SpecialAgreement'})
      : this.requestUpdateItem.emit({iri: this.presets$.getValue()['@id'], payload, entity: 'SpecialAgreement'});
  }
}
